import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "item__table__header__inner" }

import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { i18n } from '@/i18n';
import { computed, inject, Ref, ref, toRef } from 'vue';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';
import { HeaderList, TableType } from '@/coreDomainsModule/table';
import { useColumnResizer } from '@/corePagesModule/composables/useColumnResizer';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { LIST_VIEW_SECTION_INJECTION_KEY } from '../constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListViewSectionTable',
  props: {
    businesses: {},
    checkedBusinessId: {},
    tableType: {},
    fullHeaderOptions: {},
    headerList: {},
    isAggregateBusiness: { type: Boolean }
  },
  emits: ["onToggleHeader", "onCheckedRow"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const vm = new InventoryDashboardViewModel();

const props = __props;
const emits = __emit;

const tableWidthInfo = inject<Ref<Record<string, number | undefined>>>(LIST_VIEW_SECTION_INJECTION_KEY);
if (!tableWidthInfo) throw new Error('tableWidthInfoがない');

const tableTypeRef = toRef(props, 'tableType');
const tableRef = ref<HTMLElement | null>(null);

const { onMousedownResizer } = useColumnResizer({
  tableType: tableTypeRef,
  widthInfo: tableWidthInfo,
  tableEl: tableRef,
});

const modifiableHeaders = computed(
  (): HeaderList =>
    props.fullHeaderOptions
      .filter((h) => !['checkbox', 'detail', 'headerModify'].includes(h.key))
      .map((h) => ({
        key: h.key,
        text: vm.convertHeaderKeyToDisplayValue(h.key),
        isShown: props.headerList.includes(h.key),
      }))
);

const gridTemplateColumns = computed(() =>
  props.fullHeaderOptions
    .filter((header) => props.headerList.includes(header.key))
    .map((h) => {
      const saved = tableWidthInfo.value[h.key];
      return saved ? `${saved}px` : `minmax(${h.width}px, ${h.width}fr)`;
    })
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(EzTable, {
    ref_key: "tableRef",
    ref: tableRef,
    "grid-template-columns": gridTemplateColumns.value,
    "sticky-header": "",
    "is-vertical-scrollable": "",
    class: "item__table__container"
  }, {
    header: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerList.slice(0, -1), (header) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: header }, [
          (header === 'checkbox')
            ? (_openBlock(), _createBlock(EzHeader, {
                key: 0,
                class: "item__table__header"
              }, {
                default: _withCtx(() => [
                  _createVNode(RowCheckBox)
                ], undefined, true),
                _: 1
              }))
            : (header === 'detail')
              ? (_openBlock(), _createBlock(EzHeader, {
                  key: 1,
                  "content-padding": 0,
                  "force-center": "",
                  class: "item__table__header"
                }))
              : (_openBlock(), _createBlock(EzHeader, {
                  key: 2,
                  "use-resizer": "",
                  class: "item__table__header",
                  onResizer: (e) => _unref(onMousedownResizer)(e, header)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(vm).convertHeaderKeyToDisplayValue(header)), 1)
                  ], undefined, true),
                  _: 2
                }, 1032, ["onResizer"]))
        ], 64))
      }), 128)),
      _createVNode(EzHeader, { sticky: "right" }, {
        default: _withCtx(() => [
          _createVNode(TableHeaderModifyButton, {
            "modifiable-header-list": modifiableHeaders.value,
            onToggle: _cache[0] || (_cache[0] = (key, isHide) => emits('onToggleHeader', key, isHide))
          }, null, 8, ["modifiable-header-list"])
        ], undefined, true),
        _: 1
      })
    ]),
    body: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.businesses, (data, index1) => {
        return (_openBlock(), _createBlock(EzTableRow, {
          key: index1,
          "grid-template-columns": gridTemplateColumns.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerList.slice(0, -1), (header) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: header }, [
                (header === 'checkbox')
                  ? (_openBlock(), _createBlock(EzCell, {
                      key: 0,
                      "is-highlighted": props.checkedBusinessId.includes(data.businessId),
                      class: "item__table__cell"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(RowCheckBox, {
                          onChangeStatus: (isChecked) => emits('onCheckedRow', data.businessId, isChecked)
                        }, null, 8, ["onChangeStatus"])
                      ], undefined, true),
                      _: 2
                    }, 1032, ["is-highlighted"]))
                  : (header === 'detail')
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 1,
                        "content-padding": 0,
                        "is-highlighted": props.checkedBusinessId.includes(data.businessId),
                        class: "item__table__cell"
                      }, {
                        default: _withCtx(() => [
                          (data.businessId)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 0,
                                to: 
                props.isAggregateBusiness
                  ? { name: 'recommend-order', params: { id: data.businessId } }
                  : { name: 'customer-forecast-timeline', params: { defaultBusinessId: data.businessId } }
              ,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TextButton, {
                                    class: "table-detail-button",
                                    "button-style": "btn-secondary",
                                    "on-click": () => {}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted"]))
                    : (
              ['aggregateBusinessResponsibleUsers', 'baseBusinessResponsibleUsers', 'forecastForReceiptResponsibleUsers'].includes(header)
            )
                      ? (_openBlock(), _createBlock(EzCell, {
                          key: 2,
                          "is-highlighted": props.checkedBusinessId.includes(data.businessId),
                          class: "item__table__cell"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(vm).convertUserAccountToDisplayValue(data[header])), 1)
                          ], undefined, true),
                          _: 2
                        }, 1032, ["is-highlighted"]))
                      : (_unref(vm).numberHeaderKeys.includes(header))
                        ? (_openBlock(), _createBlock(EzCell, {
                            key: 3,
                            "is-number": "",
                            "is-highlighted": props.checkedBusinessId.includes(data.businessId),
                            class: "item__table__cell"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(vm).convertNumberStringToDisplayValue(header, data[header])), 1)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["is-highlighted"]))
                        : (_openBlock(), _createBlock(EzCell, {
                            key: 4,
                            "is-highlighted": props.checkedBusinessId.includes(data.businessId),
                            class: "item__table__cell"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data[header] ?? '--'), 1)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["is-highlighted"]))
              ], 64))
            }), 128)),
            _createVNode(EzCell)
          ], undefined, true),
          _: 2
        }, 1032, ["grid-template-columns"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["grid-template-columns"]))
}
}

})